module.exports = __webpack_public_path__ + "img/ymzxc.b42012b3.png";